import { Component, EventEmitter, Input, OnInit, OnChanges, Output } from '@angular/core';
import { AutocompleteOption } from '../field-text/field-text.component';
import { environment } from '../environment';

export interface FaceDetection {
  id: number;
  thumbnail: string;
  person?: any;
  mediaId?: number;
  mediaPreview?: string;
  x?: number;
  x_percent?: number;
  y?: number;
  y_percent?: number;
  width?: number;
  width_percent?: number;
  height?: number;
  height_percent?: number;
  confidence?: number;
  // Calculated container coordinates for object-fit positioning
  containerX?: number;
  containerY?: number;
  containerWidth?: number;
  containerHeight?: number;

}

@Component({
  selector: 'app-face-matching',
  templateUrl: './face-matching.component.html',
  styleUrls: ['./face-matching.component.scss']
})
export class FaceMatchingComponent implements OnInit, OnChanges {
  @Input() mediaId?: number;
  @Input() disabled = false;
  @Input() faces: FaceDetection[] = [];
  @Input() showMediaPreview = true;

  @Output() facePersonChange: EventEmitter<{
    faceId: number;
    person: AutocompleteOption | undefined;
  }> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
    // Only ensure thumbnails are set, don't reset the array
    if (this.faces && this.faces.length > 0) {
      // Ensure all faces have thumbnails but avoid creating new array
      this.faces.forEach(face => {
        if (!face.thumbnail) {
          face.thumbnail = face.mediaPreview || '/assets/no-image.svg';
        }
      });
    }
  }

  ngOnChanges(): void {
    // Only ensure thumbnails without replacing the entire array
    if (this.faces && this.faces.length > 0) {
      this.faces.forEach(face => {
        if (!face.thumbnail) {
          face.thumbnail = face.mediaPreview || '/assets/no-image.svg';
        }
      });
    }
  }

  trackByFaceId(index: number, face: FaceDetection): number {
    return face.id;
  }

  onPersonChange(event: { faceId: number; person: AutocompleteOption | undefined }): void {
    this.facePersonChange.emit(event);

    // Update the local face data
    const faceIndex = this.faces.findIndex(face => face.id === event.faceId);
    if (faceIndex >= 0) {
      this.faces[faceIndex].person = event.person;
    }
  }

  buildUrl(url: string | undefined): string {
      if (url == undefined) return '';

      if (url.split('/')[1] === 'assets') return url;

      if (url.includes('https://') || url.includes('http://') || url.startsWith('data:')) {
        return url;
      }

      return environment.productServingUrl + url;
    }
}
